module.exports = __webpack_public_path__ + "static/media/BG.8651749a.png";